export const useProjectRenderer = () => {
    return 'ffmpeg';
};
